/**
 * Normaliza valor de quota da API Civitatis.
 *
 * REGRAS (Documentação Oficial Civitatis - Calendario V2):
 * - quota = -1: Disponibilidade ILIMITADA (não bloqueia)
 * - quota = 0: SEM vagas (bloqueia)
 * - quota > 0: Quantidade específica de vagas
 * - null/undefined: Campo ausente (não bloqueia)
 */
export const normalizeQuota = (value) => {
	if (value === null || value === undefined || value === "") return null;
	const n = Number(value);
	if (Number.isNaN(n)) return null;
	return Math.trunc(n);
};

export const sessionQuota = (session) =>
	normalizeQuota(session?.quota ?? session?.availability ?? session?.vacancies);

/**
 * A modalidade/horário comporta a quantidade de pessoas escolhida?
 * Serviço privativo (isGroup) ocupa uma vaga do horário, não uma por passageiro.
 * Quota -1 (ilimitada) não bloqueia e não exibe mensagem.
 */
export const sessionAvailability = (session, pax, isGroup = false) => {
	const quota = sessionQuota(session);
	const needed = isGroup ? 1 : Math.max(1, Number(pax) || 0);

	if (quota === null || quota === -1) return { quota, bookable: true, message: null };
	if (quota === 0) return { quota, bookable: false, message: "Sem disponibilidade para esta data e horário" };
	if (quota < needed) {
		return {
			quota,
			bookable: false,
			message: `Restam apenas ${quota} ${quota === 1 ? "vaga" : "vagas"} para esta data e horário`,
		};
	}
	return { quota, bookable: true, message: quota <= 5 ? `Últimas ${quota} vagas` : null };
};

/**
 * Melhor quota entre as opções de uma data (null quando a API não informa nenhuma).
 * Quota -1 (ilimitada) é a melhor possível.
 */
export const maxSessionQuota = (sessions) => {
	const quotas = (sessions || []).map(sessionQuota).filter((q) => q !== null);
	if (quotas.length === 0) return null;
	// Se qualquer opção é ilimitada, o dia inteiro é ilimitado
	if (quotas.some((q) => q === -1)) return -1;
	return Math.max(...quotas);
};

/**
 * Mensagem de bloqueio da data inteira, antes de o cliente avançar.
 * Serviço privativo ocupa uma vaga do horário, não uma por passageiro.
 * Quota -1 (ilimitada) não bloqueia.
 */
export const dayAvailabilityError = (quota, pax, isGroup = false) => {
	if (quota === null || quota === undefined || quota === -1) return null;
	const needed = isGroup ? 1 : Math.max(1, Number(pax) || 0);
	if (quota === 0) return "Não há disponibilidade para esta data.";
	if (quota < needed) {
		return `Para esta data restam apenas ${quota} ${quota === 1 ? "vaga" : "vagas"}. Ajuste a quantidade de pessoas.`;
	}
	return null;
};

/**
 * Opções realmente vendáveis.
 * Quota 0 não pode ser oferecida.
 * Quota -1 (ilimitada) e quota não informada continuam vendáveis.
 */
export const bookableSessions = (sessions) =>
	(sessions || []).filter((s) => {
		const q = sessionQuota(s);
		return q === null || q === -1 || q > 0;
	});
